<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { AtomText, AtomImage } from "@chatfood/design-system";
import { SocialMediaLinks } from "../social-media-links";
import { useBusinessStore } from "~/stores/business";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("web-footer");

const business = useBusinessStore();
const { t } = useLocale();
const CURRENT_YEAR = new Date().getFullYear();
</script>

<template>
  <footer :class="css('')">
    <AtomImage
      v-if="business.logo"
      data-test="logo"
      :class="css('logo')"
      :alt="business.name"
      :src="business.logo"
      type="circle"
    />
    <SocialMediaLinks hide-title />
    <div :class="css('copy-right-box')">
      <AtomText color="color-text-disabled">
        {{
          t("components.web_footer.copyrights", {
            brandName: business.name,
            currentYear: CURRENT_YEAR,
          })
        }}
      </AtomText>
      <a
        v-if="business.termsAndConditionsLink"
        :class="css('links')"
        :href="business.termsAndConditionsLink"
        target="_blank"
        data-test="terms-link"
      >
        {{ t("components.web_footer.terms_and_conditions") }}
      </a>
      <a
        v-if="business.privacyPolicyLink"
        :class="css('links')"
        :href="business.privacyPolicyLink"
        target="_blank"
        data-test="privacy-link"
      >
        {{ t("components.web_footer.privacy_policy") }}
      </a>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.web-footer {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__logo {
    margin-bottom: var(--spacing-lg);
    box-shadow: var(--elevation-level-1);
  }

  &__media-links-box {
    gap: var(--spacing-md);
    display: flex;
    flex-direction: column;
  }

  &__media-link {
    text-decoration: underline;
    text-decoration-color: var(--color-text-secondary);
  }

  &__copy-right-box {
    text-align: center;
    margin-top: var(--spacing-lg);
    color: var(--color-text-disabled);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  &__links {
    text-decoration: underline;
    color: var(--color-text-disabled);
  }

  @media (width >= $breakpoint-sm) {
    &__media-links-box {
      flex-direction: row;
    }

    &__copy-right-box {
      margin-top: var(--spacing-md);
      flex-direction: row;
    }
  }
}
</style>
